export function SearchSuggestRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.SearchSuggest', {
		url: '/search/suggest',
		controllerAs: 'vm',
		controller: SearchSuggestCtrl,
		templateUrl: '/ng/hub/Search/Suggest/SearchSuggestCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			$title: () => 'Autosearch Suggest',
		},
	});
}

export class SearchSuggestCtrl {
	constructor(Api, $scope) {
		'ngInject';
		this.Api = Api;
		this.term = '';
		this.suggestions = [];
		$scope.$watch('vm.term', this.getSuggestions.bind(this));
	}

	getSuggestions() {
		const params = { term: this.term, limit: 25 };
		this.Api.get('/v3/posts/search/suggest', params).then(data => {
			this.suggestions = data;
		});
	}
}
